export default __webpack_public_path__ + "static/media/pet2vet.c88bd148.png";